import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class Email  {
    _originalTypeClassName = "zERP.BO.Email";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
Email.translate = translateService;
}
this.Attachments = [];
this.Id = null;
this.Subject = null;
this.Body = null;
this.CreatedDate = null;
this.To = null;
this.CC = null;
this.SentDate = null;
this.FailedSendAttempts = null;
this.Status = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Subject:any;
Body:any;
CreatedDate:any;
To:any;
CC:any;
SentDate:any;
FailedSendAttempts:any;
Status:any;
Attachments:any;
static setAttachments = ($this, items) => {
                if (items == null) items = [];
                if ($this.Attachments == null) $this.Attachments = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Attachments.length > 0) {
                    Domain.Email.removeAttachments($this, $this.Attachments[0]);
                }

                Domain.Email.addManyAttachments($this, copyItems);
            }
static addManyAttachments = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Email.addAttachments($this, items[i]);
                }
            }
static addAttachments = ($this, item) => {
                if ($this.Attachments == null) $this.Attachments = [];
                if (item == null || $this.Attachments.indexOf(item) > -1) return;
                $this.Attachments.push(item);
}
static addRangeAttachments = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Email.addAttachments($this, item));
            }
static removeAttachments = ($this, item) => {
                if ($this == null || $this.Attachments == null || $this.Attachments.indexOf(item) === -1) return;
                var _index = $this.Attachments.indexOf(item);
                $this.Attachments.splice(_index, 1);
}
static clearAttachments = ($this) => { $this.Attachments = null; }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}